module.exports = __webpack_public_path__ + "img/effect-bg.d8e24950.png";